<template>
  <mobile-responsive-shell title="Rapport fournisseur">
    <div class="pur-rpt">
      <div class="pur-rpt-filters card card-body py-3 mb-3">
        <div class="mb-2">
          <label class="form-label small mb-0">Fournisseur <span class="text-danger">*</span></label>
          <select v-model="search.supplier_reference" class="form-select form-select-sm" required>
            <option value="--">--</option>
            <option
              v-for="(supplier, index) in suppliers"
              :key="index"
              :value="supplier.reference"
              :style="
                supplier.blocked || (supplier.society && supplier.society.includes('Bloqué'))
                  ? { color: 'red' }
                  : {}
              "
            >
              {{ supplier.society }}
            </option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6">
            <label class="form-label small mb-0">Du <span class="text-danger">*</span></label>
            <input v-model="search.startDate" type="date" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small mb-0">Au <span class="text-danger">*</span></label>
            <input v-model="search.endDate" type="date" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="mb-2">
          <label class="form-label small mb-0">État de paiement</label>
          <select v-model="search.paymentStatus" class="form-select form-select-sm">
            <option value="--">--</option>
            <option value="Payé">Payé</option>
            <option value="Impayé">Impayé</option>
          </select>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-secondary btn-sm flex-fill" @click="getReport(search)">
            <i class="bi bi-funnel"></i> Rechercher
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm flex-fill" @click="refresh">
            Actualiser
          </button>
        </div>
      </div>

      <p v-if="!reports || !reports.length" class="text-muted text-center py-3">
        Aucun rapport. Choisissez un fournisseur et lancez la recherche.
      </p>

      <article
        v-for="(report, index) in reports"
        :key="index"
        class="pur-rpt-block"
      >
        <div class="pur-rpt-invoice">
          <dl class="pur-rpt-kv">
            <div><dt>Date</dt><dd>{{ report.date }}</dd></div>
            <div><dt>Total</dt><dd>{{ report.totalPriceTTC }}</dd></div>
            <div><dt>Payé</dt><dd class="text-success">{{ report.amountPaid }}</dd></div>
            <div><dt>Impayé</dt><dd class="text-danger">{{ report.amountUnpaid }}</dd></div>
          </dl>
          <button type="button" class="btn btn-primary btn-sm w-100" @click="viewDetails(report)">
            Afficher la facture
          </button>
        </div>
        <div class="pur-rpt-lines">
          <div
            v-for="(purchase_item, _index) in report.purchase_items || []"
            :key="_index"
            class="pur-rpt-line"
          >
            <div class="pur-rpt-line-name">
              <span v-if="purchase_item.item">{{ purchase_item.item.fullName }}</span>
            </div>
            <div class="pur-rpt-line-grid">
              <span>Qté {{ purchase_item.quantity }}</span>
              <span>P.U. {{ purchase_item.priceTTC }}</span>
              <span class="fw-semibold">{{ purchase_item.totalPriceTTC }}</span>
            </div>
          </div>
        </div>
      </article>

      <div v-if="reports && reports.length" class="pur-rpt-totals card card-body mt-3">
        <div class="pur-rpt-total-row">
          <span>Montant total</span>
          <span class="bg-warning px-2 rounded">{{ totalPriceTTC | toFixedWithSpace }}</span>
        </div>
        <div class="pur-rpt-total-row">
          <span>Montant payé</span>
          <span class="bg-success text-white px-2 rounded">{{ totalPaid | toFixedWithSpace }}</span>
        </div>
        <div class="pur-rpt-total-row">
          <span>Montant impayé</span>
          <span class="bg-danger text-white px-2 rounded">{{ totalUnpaid | toFixedWithSpace }}</span>
        </div>
        <div class="pur-rpt-total-row">
          <span>Quantité totale</span>
          <span class="bg-secondary text-white px-2 rounded">{{ totalQuantity | toFixedWithSpace }}</span>
        </div>
      </div>

      <div v-if="reports && reports.length" class="text-end mt-3">
        <button type="button" class="btn btn-secondary btn-sm" @click="print(search)">
          <i class="bi bi-cloud-arrow-down"></i> Télécharger
        </button>
      </div>
    </div>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobilePurchasesSupplierReport",
  components: { MobileResponsiveShell },
  data() {
    return {
      search: {
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      },
    };
  },
  beforeMount() {
    this.$store.dispatch("supplier/getAll");
    this.$store.dispatch("purchase/reportSupplier", this.search);
  },
  computed: {
    ...mapGetters("supplier", { suppliers: "getAll" }),
    ...mapGetters("purchase", {
      reports: "getReport",
      totalUnpaid: "getReportTotalUnpaid",
      totalPaid: "getReportTotalPaid",
      totalPriceTTC: "getReportTotalPriceTTC",
      totalQuantity: "getReportTotalQuantity",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("supplier/getAll");
      this.search = {};
    },
    async getReport(data) {
      await this.$store.dispatch("purchase/reportSupplier", data);
    },
    async print(data) {
      await this.$store.dispatch("purchase/printReportSupplier", data);
    },
    viewDetails(report) {
      if (report && report.reference) {
        this.$router.push({
          name: "mobile-purchases-details",
          params: { reference: report.reference },
        });
      }
    },
  },
  filters: {
    toFixedWithSpace: (value) => {
      if (value === undefined || value === null || value === "") return "—";
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>

<style scoped>
.pur-rpt-filters {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.pur-rpt-block {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 0.75rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.pur-rpt-invoice {
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #dee2e6;
}
.pur-rpt-kv {
  margin: 0 0 0.75rem;
  display: grid;
  gap: 0.35rem;
  font-size: 0.9rem;
}
.pur-rpt-kv > div {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}
.pur-rpt-kv dt {
  margin: 0;
  color: #6c757d;
}
.pur-rpt-kv dd {
  margin: 0;
  font-weight: 600;
}
.pur-rpt-lines {
  padding: 0.5rem 1rem 0.75rem;
}
.pur-rpt-line {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  font-size: 0.85rem;
}
.pur-rpt-line:last-child {
  border-bottom: none;
}
.pur-rpt-line-name {
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.pur-rpt-line-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  color: #495057;
}
.pur-rpt-totals {
  border-radius: 12px;
  font-size: 0.9rem;
}
.pur-rpt-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.35rem;
}
.pur-rpt-total-row:last-child {
  margin-bottom: 0;
}
</style>
